<template>
  <div>
    <v-card
      tile
      elevation="0"
      color="transparent"
      class="d-flex justify-space-between align-center mb-3 px-2"
    >
      <div class="mr-2 text-h6">직원 휴가관리</div>
      <div>
        <v-btn
          elevation="0"
          color="#D7D3E2"
          rounded
          class="mr-3"
          @click="showConfirm = true"
        >
          휴가 등록 및 확정
        </v-btn>
        <v-btn elevation="0" color="#D7D3E2" rounded @click="showAdd = true">
          휴가 추가 부여
        </v-btn>
      </div>
    </v-card>
    <vacation-list
      :empVacations="vacList"
      @confirmVacation="confirmVacation"
    ></vacation-list>
    <v-dialog v-model="showConfirm" width="500">
      <vacation-confirm
        :empLists="empLists"
        :isShow="showConfirm"
        @registerVacation="registerVacation"
        @hideModal="hideModal"
      ></vacation-confirm>
    </v-dialog>
    <v-dialog v-model="showAdd" width="500">
      <vacation-add
        :empLists="empLists"
        :isShow="showAdd"
        @addVacation="addVacation"
        @hideModal="hideModal"
      ></vacation-add>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import VacationList from "@/components/vacation/VacationList";
import VacationConfirm from "@/components/vacation/VacationConfirm";
import VacationAdd from "@/components/vacation/VacationAdd";
import {
  listEmpVacation,
  addEmpVacation,
  regVacation,
  confirmVacation,
} from "@/api/employee";
import { getEmp } from "@/api/common";

export default {
  data() {
    return {
      showConfirm: false,
      showAdd: false,
      vacList: [],
      empLists: [],
      snackbar: {
        message: "",
        show: false,
      },
    };
  },
  components: { VacationList, VacationConfirm, VacationAdd },
  created() {
    this.loadList();
    this.loadEmp();
  },
  methods: {
    hideModal() {
      this.showAdd = false;
      this.showConfirm = false;
    },
    showResult(ret) {
      if (ret > 0) {
        this.snackbar.message = "저장되었습니다.";
        this.snackbar.show = true;
        this.hideModal();
        this.loadList();
      } else {
        this.snackbar.message = "저장 실패.";
        this.snackbar.show = true;
        this.hideModal();
      }
    },
    async loadEmp() {
      try {
        const { data } = await getEmp();
        const list = data.list.map(v => {
          return {
            empNo: v.empNo,
            empNm: v.empNm,
          };
        });

        this.empLists = list;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async loadList() {
      try {
        const { data } = await listEmpVacation();
        const list = data.form.map(v => {
          // date, time formatting
          const stDate = moment(v.planStDt).format("YYYY-MM-DD");
          const edDate = moment(v.planEdDt).format("YYYY-MM-DD");
          const stTime = moment(v.planStTm, "hmm").format("HH:mm");
          const edTime = moment(v.planEdTm, "hmm").format("HH:mm");

          const end = moment(v.planEdDt);
          const start = moment(v.planStDt);
          const diff = moment.duration(end.diff(start)).asDays();
          // diff 값이 0이면 시작일만 표시
          const duration = diff === 0 ? stDate : `${stDate} ~ ${edDate}`;

          const newList = {
            ...v,
            planDt: duration,
            planTm: `${stTime} ~ ${edTime}`,
          };

          return newList;
        });

        this.vacList = list.reverse();
      } catch (error) {
        console.log(error);
      }
    },
    async addVacation(addData) {
      try {
        const { day, empList, note } = addData;
        const { data } = await addEmpVacation(day, empList, note);

        this.showResult(data.ret);
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async registerVacation(addData) {
      try {
        const { data } = await regVacation(addData);
        this.showResult(data.ret);
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async confirmVacation(empNo, planNo) {
      try {
        const { data } = await confirmVacation(empNo, planNo);

        if (data.ret > 0) {
          this.snackbar.message = "확정되었습니다.";
          this.snackbar.show = true;
          this.loadList();
        } else {
          this.snackbar.message = "확정 실패.";
          this.snackbar.show = true;
        }
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },
};
</script>

<style></style>
